<template>
  <div class="flex gap-1 justify-between bg-layer-3 opacity-90 min-w-[10rem] rounded p-2 relative">
    <slot />
  </div>
</template>
